import {
  DeviceAvailabilityCalendarPoint,
  DeviceAvailabilityCalendarQuery,
  DevicePmpBooking,
  DevicePmpBookingQuery,
  DeviceAvailabilityList,
  DeviceAvailabilityQuery,
  DeviceChannel,
  DeviceUnitDetail,
  DeviceUnitExportQuery,
  DeviceUnitList,
  DeviceUnitQuery
} from './DeviceManagement';
import {
  DeviceManagementWebService,
  RestfulDeviceManagementWebService
} from 'ws/DeviceManagementWebService';

export interface DeviceManagementManager {
  getChannels(): Promise<DeviceChannel[]>;
  getUnits(query: DeviceUnitQuery): Promise<DeviceUnitList>;
  getUnitDetail(channelId: number, unitKey: string): Promise<DeviceUnitDetail>;
  /** 檔名以回應的 Content-Disposition 為準，讀不到才用 fallbackFileName。 */
  exportUnits(
    query: DeviceUnitExportQuery,
    fallbackFileName: string
  ): Promise<void>;
  getAvailability(
    query: DeviceAvailabilityQuery
  ): Promise<DeviceAvailabilityList>;
  getAvailabilityCalendar(
    query: DeviceAvailabilityCalendarQuery
  ): Promise<DeviceAvailabilityCalendarPoint[]>;
  getPmpBookings(query: DevicePmpBookingQuery): Promise<DevicePmpBooking[]>;
}

export class DefaultDeviceManagementManager implements DeviceManagementManager {
  webService: DeviceManagementWebService;

  constructor(
    webService: DeviceManagementWebService = new RestfulDeviceManagementWebService()
  ) {
    this.webService = webService;
  }

  getChannels(): Promise<DeviceChannel[]> {
    return this.webService.getChannels();
  }

  getUnits(query: DeviceUnitQuery): Promise<DeviceUnitList> {
    return this.webService.getUnits(query);
  }

  getUnitDetail(channelId: number, unitKey: string): Promise<DeviceUnitDetail> {
    return this.webService.getUnitDetail(channelId, unitKey);
  }

  exportUnits(
    query: DeviceUnitExportQuery,
    fallbackFileName: string
  ): Promise<void> {
    return this.webService.exportUnits(query, fallbackFileName);
  }

  getAvailability(
    query: DeviceAvailabilityQuery
  ): Promise<DeviceAvailabilityList> {
    return this.webService.getAvailability(query);
  }

  getAvailabilityCalendar(
    query: DeviceAvailabilityCalendarQuery
  ): Promise<DeviceAvailabilityCalendarPoint[]> {
    return this.webService.getAvailabilityCalendar(query);
  }

  getPmpBookings(query: DevicePmpBookingQuery): Promise<DevicePmpBooking[]> {
    return this.webService.getPmpBookings(query);
  }
}
